import AppTimerCounterTypography from 'components/typographies/AppTimerCounterTypography';
import {useGetAllTimeTrackerEntitiesWithoutPagination} from 'hooks';
import React, {useEffect, useMemo} from 'react';
import {useSelector} from 'react-redux';
import {timeTrackerSelector} from 'store/timeTracker';

interface ItemSummaryTimeTrackerCounterProps {
    itemDataId: string;
}
// Function to control the rendering of the timer based on itemDataId and lastCounterValue

const ItemSummaryTimeTrackerBase: React.FC<ItemSummaryTimeTrackerCounterProps> = ({itemDataId: itemDateId}) => {
    const {getAllTimeTrackerEntitiesWithoutPagination, getAllTimeTrackerEntitiesWithoutPaginationResponse} =
        useGetAllTimeTrackerEntitiesWithoutPagination();
    // Store the last counter value when timer stops
    const {counterValueInRedux, selectedTimeTrackInRedux} = useSelector(timeTrackerSelector);
    const [lastCounterValue, setLastCounterValue] = React.useState(0);
    const [selectTimerTrackerItem, setSelectedTimeTrackerItemId] = React.useState('');
    useEffect(() => {
        if (counterValueInRedux > 0) {
            setLastCounterValue(counterValueInRedux);
            if (selectedTimeTrackInRedux?.itemDataId) {
                setSelectedTimeTrackerItemId(selectedTimeTrackInRedux.itemDataId);
            }
        }
    }, [counterValueInRedux]);

    useEffect(() => {
        if (itemDateId) {
            getAllTimeTrackerEntitiesWithoutPagination({
                variables: {
                    where: {
                        itemDataId: {
                            eq: itemDateId,
                        },
                    },
                },
            });
        }
    }, [itemDateId, getAllTimeTrackerEntitiesWithoutPagination]);

    // Update lastCounterValue when timer stops

    // Calculate total duration from all completed entries
    const totalTrackerValue = useMemo(() => {
        if (!getAllTimeTrackerEntitiesWithoutPaginationResponse) return 0;

        return getAllTimeTrackerEntitiesWithoutPaginationResponse.reduce(
            (acc, curr) => acc + (curr.durationInSeconds || 0),
            0,
        );
    }, [getAllTimeTrackerEntitiesWithoutPaginationResponse]);

    // Render timer with proper total calculation
    const renderTimer = useMemo(() => {
        const isCurrentItemTracking = selectTimerTrackerItem === itemDateId;
        let totalTime = totalTrackerValue;

        if (isCurrentItemTracking) {
            totalTime = totalTime + lastCounterValue;
        }

        return <AppTimerCounterTypography counterValueInSeconds={totalTime} />;
    }, [selectTimerTrackerItem, itemDateId, totalTrackerValue, lastCounterValue]);

    return <>{renderTimer}</>;
};

export const ItemSummaryTimeTrackerCounter = React.memo(ItemSummaryTimeTrackerBase);

export default ItemSummaryTimeTrackerCounter;
